module.exports = __webpack_public_path__ + "img/p1_r.084d8e45.jpg";